import { Injectable } from '@angular/core';

export class MatchTypeField {

  id: number;
  name: string;
  required: boolean;

  constructor(d: any) {
    this.id = d.id;
    this.name = d.name;
    this.required = d.required;
  }
}

export class MatchTypeItem {
  id: number;
  subjectTypeId: number;
  name: string;
  fields: MatchTypeField[];

  constructor(d: any) {
    this.id = d.id;
    this.name = d.name;
    this.subjectTypeId = d.subjectTypeId;
    this.fields = d.fields;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MatchTypesServices {
  public static MatchTypes: MatchTypeItem[] = [
    {
      id: 2,
      name: 'Address',
      subjectTypeId: undefined,
      fields: [{ id: 1, name: 'Address Line 1', required: true },
      { id: 2, name: 'Address Line 2', required: true },
      { id: 3, name: 'Address Line 3', required: false },
      { id: 4, name: 'Address Line 4', required: false },
      { id: 5, name: 'Postcode', required: true },
      { id: 6, name: 'Telephone', required: false },
      ],
    },
    {
      id: 8,
      subjectTypeId: undefined,
      name: 'Organisation',
      fields: [{ id: 1, name: 'Organisation Name', required: true },
      { id: 2, name: 'Email', required: false },
      { id: 3, name: 'Website', required: false },
      { id: 4, name: 'Telephone', required: false },
      ]
    },
    {
      id: 1,
      name: 'Person',
      subjectTypeId: undefined,
      fields:
        [{ id: 1, name: 'Title', required: false },
        { id: 2, name: 'First Name', required: true },
        { id: 3, name: 'Last Name', required: true },
        { id: 4, name: 'NINO', required: false },
        { id: 5, name: 'Email Address', required: false },
        { id: 6, name: 'Date of Birth', required: false },
        { id: 7, name: 'Mobile Telephone', required: false },
        { id: 8, name: 'Sort Code', required: false },
        { id: 9, name: 'Account Number', required: false },
        ],
    },
    {
      id: 4,
      name: 'Vehicle',
      subjectTypeId: undefined,
      fields: [{ id: 1, name: 'Registration', required: true },
      ],
    },
  ];

  constructor() { }
}
